/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetNetworkWxdomainRequest = { domain: string };

export const GetNetworkWxdomainRequest$zodSchema: z.ZodType<
  GetNetworkWxdomainRequest
> = z.object({
  domain: z.string().describe("需要查询的域名。"),
});

export type GetNetworkWxdomainBadGatewayDetails = {};

export const GetNetworkWxdomainBadGatewayDetails$zodSchema: z.ZodType<
  GetNetworkWxdomainBadGatewayDetails
> = z.object({});

/**
 * 查询上游接口失败。
 */
export type GetNetworkWxdomainBadGatewayResponseBody = {
  code?: string | undefined;
  details?: GetNetworkWxdomainBadGatewayDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkWxdomainBadGatewayResponseBody$zodSchema: z.ZodType<
  GetNetworkWxdomainBadGatewayResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkWxdomainBadGatewayDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("查询上游接口失败。");

export type GetNetworkWxdomainBadRequestDetails = {};

export const GetNetworkWxdomainBadRequestDetails$zodSchema: z.ZodType<
  GetNetworkWxdomainBadRequestDetails
> = z.object({});

/**
 * 请求参数无效。
 */
export type GetNetworkWxdomainBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetNetworkWxdomainBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkWxdomainBadRequestResponseBody$zodSchema: z.ZodType<
  GetNetworkWxdomainBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkWxdomainBadRequestDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("请求参数无效。");

/**
 * 查询成功！返回该域名在微信中的状态。
 */
export type GetNetworkWxdomainResponseBody = {
  domain?: string | undefined;
  title?: string | undefined;
  type?: string | undefined;
};

export const GetNetworkWxdomainResponseBody$zodSchema: z.ZodType<
  GetNetworkWxdomainResponseBody
> = z.object({
  domain: z.string().optional(),
  title: z.string().optional(),
  type: z.string().optional(),
}).describe("查询成功！返回该域名在微信中的状态。");

export type GetNetworkWxdomainResponse =
  | GetNetworkWxdomainResponseBody
  | GetNetworkWxdomainBadRequestResponseBody
  | GetNetworkWxdomainBadGatewayResponseBody;

export const GetNetworkWxdomainResponse$zodSchema: z.ZodType<
  GetNetworkWxdomainResponse
> = z.union([
  z.lazy(() => GetNetworkWxdomainResponseBody$zodSchema),
  z.lazy(() => GetNetworkWxdomainBadRequestResponseBody$zodSchema),
  z.lazy(() => GetNetworkWxdomainBadGatewayResponseBody$zodSchema),
]);
